import { CoerceNumberSchema, NaturalNumberSchema } from '@mntn/zod'
import { z } from 'zod'

export const AccessCheckQuerySchema = z.object({
  'advertiser-id': CoerceNumberSchema.pipe(NaturalNumberSchema),
})

const AccessCheckResponseBodySchema = z.object({
  data: z.object({
    flightDeck: z.boolean(),
    storefront: z.boolean(),
  }),
})

const AccessCheckSuccessResponseSchema = z
  .object({
    ok: z.literal(true),
    data: z.object({
      flightDeck: z.boolean(),
      storefront: z.boolean(),
    }),
  })
  .transform(({ data }) => ({ data }))
  .pipe(AccessCheckResponseBodySchema)

export const AccessCheckResponseSchema = {
  200: AccessCheckSuccessResponseSchema,
}
